export const getNoteTypes = () => ({
  path: 'note_types',
  method: 'GET',
});

export const getNoteType = (id) => ({
  path: `note_types/${id}`,
  method: 'GET',
});

export const getEntityNotes = (entityType, entityID) => ({
  path: `notes?entity_type=${entityType}&entity_id=${entityID}`,
  method: 'GET',
});

export const updateNote = (note) => ({
  path: `notes/${note.id}`,
  method: 'PUT',
  body: JSON.stringify(note),
});

export const deleteNote = (id) => ({
  path: `notes/${id}`,
  method: 'DELETE',
});

export const createNotes = (notes) => ({
  path: 'notes',
  method: 'POST',
  body: JSON.stringify(notes),
});

export const createNoteType = (label) => ({
  path: 'note_types',
  method: 'POST',
  body: JSON.stringify({ label }),
});
